import { CircleNode, CircleNodeModel, h } from '@logicflow/core';
import { getEventIconElements } from './eventIcons';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class IntermediateEventView extends CircleNode {
  getShape() {
    const { model } = this.props;
    const { x, y, r, properties } = model;
    const style = model.getNodeStyle();
    const trigger = properties.trigger || '';

    return h('g', {}, [
      // Outer circle
      h('circle', { cx: x, cy: y, r, ...style }),
      // Inner circle (BPMN double border for intermediate events)
      h('circle', {
        cx: x, cy: y, r: r - 3,
        fill: 'none', stroke: style.stroke, strokeWidth: 1,
      }),
      ...getEventIconElements(h, x, y, trigger, false, style.stroke, 1.0),
    ]);
  }
}

class IntermediateEventModel extends CircleNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.r = 18;
    initLabelOffset(this, data, this.r + 14);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'intermediateEvent');
    style.stroke = t.stroke || '#1890ff';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#ffffff';
    return style;
  }
}

export const IntermediateEvent = {
  type: 'epx:IntermediateEvent',
  view: IntermediateEventView,
  model: IntermediateEventModel,
};
